// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2QuTD","header":"Messages_header__zX8nZ"};